import NavBar from './components/NavBar';
import SideBar from './components/SideBar';
import Box from '@mui/material/Box';
import { Outlet } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import { useDisclosure } from '../../hooks/useDisclosure';
import { isMobile } from '../../utils';
import useResponsive from '../../hooks/useResponsive';

const drawerWidth = 240;

export default function DashboardLayout() {
  const drawerDisclosure = useDisclosure();

  const isSmallDesktop = useResponsive('down', 'md');
  const isMobileOrSmallDesktop = isSmallDesktop || isMobile;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <NavBar isMobileOrSmallDesktop={isMobileOrSmallDesktop} drawerWidth={drawerWidth} onDrawerToggle={drawerDisclosure.toggle} />
      <SideBar isMobileOrSmallDesktop={isMobileOrSmallDesktop} mobileOpen={drawerDisclosure.isOpen} onDrawerToggle={drawerDisclosure.toggle} onDrawerClose={drawerDisclosure.close} />

      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { xs: `calc(100% - ${drawerWidth}px)` } }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );

}